export interface GameControlsOptions {
  canStart: () => boolean;
  start: () => void;
  restart: () => void;
  pause: (paused: boolean) => void;
  muted: () => boolean;
  toggleSound: () => void;
}

/** Operator actions stay on the host. A controller does not acquire them. */
export function mountGameControls(options: GameControlsOptions) {
  let paused = false;
  const toolbar = document.createElement('nav');
  toolbar.className = 'game-controls'; toolbar.setAttribute('aria-label', 'Game controls');
  const make = (label: string, action: () => void) => {
    const button = document.createElement('button'); button.type = 'button';
    button.textContent = label; button.addEventListener('click', action);
    toolbar.append(button); return button;
  };
  const start = make('START GAME', () => { if (options.canStart()) options.start(); });
  const pause = make('PAUSE', () => { paused = !paused; options.pause(paused); update(); });
  const sound = make('SOUND', () => { options.toggleSound(); update(); });
  make('NEW GAME', () => {
    if (!window.confirm('Start a new game? Current game scores will reset.')) return;
    paused = false; options.pause(false); options.restart(); update();
  });
  const status = document.createElement('span'); status.setAttribute('role', 'status');
  toolbar.append(status); document.body.append(toolbar);
  const update = () => {
    start.disabled = !options.canStart(); pause.textContent = paused ? 'RESUME' : 'PAUSE';
    pause.setAttribute('aria-pressed', String(paused));
    sound.textContent = options.muted() ? 'SOUND OFF' : 'SOUND ON';
    sound.setAttribute('aria-pressed', String(!options.muted()));
    status.textContent = paused ? 'GAME PAUSED' : '';
  };
  update();
  return { get paused() { return paused; }, update, dispose: () => toolbar.remove() };
}
